export enum RoutesEnum {
	Root = '',
	Home = 'home',
	Alerts = 'mis-equipos/alertas',
	Users = 'usuarios',
	MyMachines = 'mis-equipos',
	Map = 'mis-equipos/mapa',
	Machines = 'equipos',
	Companies = 'empresas',
	Auth = 'authentication',
	Events = 'equipos/eventos',
	MyReports = 'mis-equipos/mis-reportes',
	Reports = 'equipos/reportescnf',
	Maintenance = 'mantenimiento',
	MantenimientoReportComponent ='mantenimiento/mantenimientos-reportes'
}
